import React, { useEffect } from 'react'

import AOS from 'aos';
import 'aos/dist/aos.css';

import Home from './components/organisation/home';
import Levels from './components/organisation/levels';
//import Questions from '../../superseeded/questions';
import ListedQuestion from './components/process/processes';
//import Main from './components/ai/main';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
//import Stop from './components/organisation/eliminated';
//import success from './components/organisation/congratulations';
import LandingPage from './components/organisation/landingPage';
import NoPage from './components/process/errorpage';
//import TestingGround from './components/process/testing'
import Footer from './components/organisation/footer/Footer';

import Blog from './components/mis/blog';
import Terms from './components/mis/terms';
import Privacy from './components/mis/Privacy';
import Contact from './components/mis/contact';

function App() {

  useEffect(() => {
    
    AOS.init();
    
  }, []);

  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    
    return (
      <div>
        <h1>Currently our platform is still in BETA and doesn't support mobile devices. Please use our platform on a desktop or PC. Apologies for the inconvenience, we're looking into this.</h1>
      </div>
    );

   } else {

  return (
    <div >
      <Router>
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/languages" component={Home} />
          <Route exact path="/levels" component={Levels} />
          <Route exact path="/questions" component={ListedQuestion} />
          <Route exact path="/lessons" component={Blog} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/contact" component={Contact} />
          <Route path="/:error" component={NoPage} />
        </Switch>
    </Router>
    </div>
  );
}
}

export default App;
